var lastOnetrustUpdate = '2022/06/14, 16:51';
export default lastOnetrustUpdate;